import React, { useState } from "react";
import './style.css';
import Headder from "../Header";
import { Images, Strings, Href } from '../../Constants';
import { FaqNavbar, Rewards } from '../../components';
import { Config } from '../../Configs';
import ModalPopup from "../ModalPopup";
import Popup from "reactjs-popup";

const rewardCardDetails = [
    {
        img: Images.reward,
        cardTitle: Strings.CARD_FEATURE_SUBTITLE_ONE,
        cardSubTitle: Strings.CARD_FEATURE_SUBTITLEONE
    },
    {
        img: Images.spin,
        cardTitle: Strings.CARD_FEATURE_SUBTITLE_TWO,
        cardSubTitle: Strings.CARD_FEATURE_SUBTITLETWO
    },
    {
        img: Images.secure,
        cardTitle: Strings.CARD_FEATURE_SUBTITLE_THREE,
        cardSubTitle: Strings.CARD_FEATURE_SUBTITLETHREE
    }
]

const cardDetails = [
    {
        recommended: true,
        cardImg: Images.eliteCard,
        cardTitle: "Elite Card",
        price: "₹999",
        pricePer: "/ ONE TIME CHARGE",
        border: '1px solid #C9A67A',
        marginRight: '60px',
        bgColor: 'linear-gradient(180deg, #1A1917 0%, #2D2212 100%)',
        features: [
            {
                featureText: "1.5% Fixed Reward Percentage"
            },
           /*  {
                featureText: "₹250 Preloaded Balance"
            }, */
            {
                featureText: "6% Increased cashback boost on Myntra"
            },
            {
                featureText: "Boosted cashback on Vouchers"
            },
            {
                featureText: "Zero Annual Fees"
            }
        ]
    },
    {
        recommended: false,
        cardImg: Images.introCard,
        cardTitle: "Intro Card",
        price: "₹399",
        pricePer: "/ ONE TIME CHARGE",
        border: 'none',
        bgColor: '#141516',
        features: [
            {
                featureText: "0.5% Fixed Reward Percentage"
            },
            /* 
            {
                featureText: "₹100 Preloaded Balance "
            }, */
            {
                featureText: "3.25% Increased cashback boost on Myntra"
            },
            {
                featureText: "Boosted cashback on Vouchers"
            },
            {
                featureText: "Zero Annual Fees"
            }
        ]
    }
]

const CardScreen = () => {

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>
            <CardLandingScreen />
            <Rewards />
            {/* <GosatsCard /> */}
            <ChooseCard />
            <FAQ />
        </div>
    )
}

const CardLandingScreen = () => {
    return (
        <div className='cardScreenMain'>
            <div className='cardScreen '>
                <div className='container cardScreenSectionOne'>
                    <Headder />
                    <div className='col-md-12 col-lg-12 col-xl-12 card-homeScreen-title-container' >
                        <div className="col-sm-6 col-md-12 col-lg-6 col-xl-6">
                            <div className='homeScreen-title' >
                                <div className='head-title-card col-12 col-md-12 col-lg-12 col-xl-12'>Get India's first Sats Rewards Card</div>
                                <div className=' cardScreen-sub-title col-12 col-md-12 col-lg-12 col-11 col-xl-11' >{Strings.CARD_REVOLUTION}</div>
                            </div>
                            <div className='col-12 col-md-12 cardScreen-card-mob ' >
                                <img className='card-homeScreen-img'
                                    src={Images.cardLandingImg}
                                    alt='GoSats' />
                            </div>
                            <div>
                                <div className='col-md-12 col-lg-12 downloadLinks'>
                                    <DownloadableButtons />
                                </div>
                                <div className='downloadTitle'>Trusted by <span className='downloadTitleLinear'> 5 Lakh+ Customers</span> </div>
                                <div className='downloadTitleMobile'>Trusted by <br /><span className='downloadTitleLinearMobile'> 5 Lakh+ Customers</span> </div>
                            </div>
                        </div>
                        <div className='col-12 col-md-6 col-lg-4 col-xl-4 cardScreen-card ' >
                            <img className='card-homeScreen-img'
                                src={Images.cardLandingImg}
                                alt='GoSats' />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


const DownloadableButtons = () => {
    return (

        <div className="col-12 col-md-12 col-lg-12 col-xl-12 d-flex  downloadLinksContainer" >
            <div className="col-md-4 col-lg-7 col-xl-6 button-appStore playstore" >
                <a href="https://gosats.onelink.me/O1LB/486vmbyi"
                    target="_blank" rel="noreferrer">
                    <img src={Images.playstore}
                        className="googlePlayLogo"
                        alt="Google play"
                        style={{ width: 126, hight: 40 }}
                    />
                </a>

            </div>
            <div className="col-md-4 col-lg-4 col-xl-6 button-appStore appstore" >
                <a href="https://gosats.onelink.me/O1LB/3n15ro4v"
                    target="_blank" rel="noreferrer">
                    <img src={Images.appstore}
                        className="appStoreLogo"
                        alt="App Store"
                        style={{ width: 126, hight: 40 }}
                    />
                </a>
            </div>
        </div>
    )
}

const GosatsCard = () => {
    return (
        <div className="container sectionTwoContainer">
            <div className="sectionTwoTitle">{Strings.CARD_FEATURE_TITLE}</div>
            <div className='cardHomebg'></div>
            <div className="sectionTwoCards">
                {
                    rewardCardDetails.map((data, index) => (
                        <div className="cards" key={index}>
                            <img className="cardRewardImg" src={data.img} alt="" />
                            <div className="cardHeader">{data.cardTitle}</div>
                            <div className="gosatsCardSubTitle">{data.cardSubTitle}</div>
                        </div>
                    ))

                }
            </div>
        </div>
    )
}

const ChooseCard = () => {

    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const handlePopup = () => {
        setIsPopupOpen(true);
    };

    return (
        <div className="container chooseCardContainer col-12 col-md-12 col-lg-10 col-xl-7">
            <div className="sectionTwoTitle">{Strings.CHOOSE_CARD_TITLE}</div>
            {/* <div className="chooseCard-sub-title">{Strings.CHOOSE_CARD_SUBTITLE}</div> */}
            <div className="cardDetailsContainer ">
                <div className="chooseCardOneContainer">
                    {cardDetails.map((data, index) => (
                        <div className="chooseCardOne" style={{ border: data.border, background: data.bgColor, marginRight: '20px' }} key={index}>
                            <div>
                                {data.recommended ? <div className="recommendedCard">Recommended</div> : ""}
                            </div>
                            <img className="cardImg" src={data.cardImg} alt="card" />
                            <div className="chooseCardTitle">{data.cardTitle}</div>
                            <div className="cardPriceContainer">
                                <div className="cardPrice">{data.price}</div>
                                <div className="perTitle">{data.pricePer}</div>
                            </div>
                            <div className="cardDivider"></div>
                            {data.features.map((feature, index) => (
                                <div className="checkPoints" key={index}>
                                    <div className="checkTitle">{feature.featureText}</div>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
            <div className="cardDownloadContainer">
                <div className="cardDownloadTitle">{Strings.CHOOSE_CARD_DOWNLOAD_TITLE}</div>
                <div>
                    <button
                        className="cardDownloadButtonTitle"
                        onClick={(e) => {
                            e.preventDefault();
                            window.location.href = Href.GOSATS_ONELINK;
                        }}
                        // onClick={()=> handlePopup()}
                    >
                        Get GoSats Card
                    </button>
                </div>
            </div>
            <Popup
                open={isPopupOpen}
                closeOnDocumentClick
                onClose={() => setIsPopupOpen(false)}
            >
                {close => (
                    <ModalPopup onClose={() => { close(); setIsPopupOpen(false); }} />
                )}
            </Popup>
        </div>
    )
}

const FAQ = () => {
    return (
        <div className='faq-container'>

            <div className='container'>
                <div className='card-faq-subsection' >
                    <div className='col-12 faq-container '>
                        <div className=' faq-title'>
                            <h2 className='faq-title'>{Strings.FAQ_TITLE}</h2>
                        </div>
                        <div className='col-11 faq-subtitle col-md-11'>
                            <p>{Strings.FAQ_SUBTITLE}<br />Please write to us at  <a href={Config.MAIL_TO} className='goto-mail'>support@gosats.io</a></p>
                        </div>
                    </div>
                    <div className='col-12  faq-navbar'>
                        <FaqNavbar />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CardScreen;